const stripeAccountLinkSelector = (
    state: sage.state.IRedux
): sage.model.IStripeAccountLink | undefined => {
    return state.user.stripeAccountLink;
};

export default stripeAccountLinkSelector;
